export function resolveWithCompanyDefault<T>(
  userVal: T | undefined,
  companyVal: T | undefined,
  systemVal: T,
): T {
  return userVal ?? companyVal ?? systemVal;
}
